<script setup lang="ts">
  import { VueFinalModal } from 'vue-final-modal';
  import { ThemeProvider, UiModalHeader } from '@/shared/ui';
  import type { NotificationDisplay } from '@/shared/lib';
  import NotificationList from './NotificationList.vue';

  withDefaults(
    defineProps<{
      title: string;
      notifications?: NotificationDisplay[];
      isLoading?: boolean;
      processingNoticeId?: number | null;
    }>(),
    {
      notifications: () => [],
      isLoading: false,
      processingNoticeId: null,
    }
  );

  const emit = defineEmits<{
    (e: 'close'): void;
    (e: 'acknowledge', id: number): void;
  }>();
</script>

<template>
  <VueFinalModal
    :model-value="true"
    class="flex items-start justify-end p-1 sm:pt-20 sm:pr-6"
    content-class="flex w-full max-w-[303px] flex-col overflow-hidden rounded-[20px] bg-white-01 shadow-[0px_12px_24px_-4px_rgba(16,24,40,0.12),0px_4px_8px_-2px_rgba(16,24,40,0.08)] max-h-[calc(100vh-8px)] sm:max-h-[calc(100vh-96px)]"
    overlay-transition="vfm-fade"
    content-transition="vfm-fade"
    :hide-overlay="true"
    @update:model-value="(isOpen) => !isOpen && emit('close')"
  >
    <ThemeProvider class="flex h-full flex-col overflow-hidden px-4 pt-4 pb-2 sm:px-3.5 sm:pt-4">
      <UiModalHeader
        :title="title"
        text-color="gray-07"
        title-size="text-xl"
        class="pb-4"
        @close="emit('close')"
      />
      <NotificationList
        :notifications="notifications"
        :is-loading="isLoading"
        :processing-notice-id="processingNoticeId"
        @acknowledge="emit('acknowledge', $event)"
        @navigate="emit('close')"
      />
    </ThemeProvider>
  </VueFinalModal>
</template>
